import {
  OPEN_DIALOG,
  CLOSE_DIALOG,
  UPDATE_HIERARCHY_TYPE,
  ADD_PROJECT,
  REMOVE_PROJECT,
  UPDATE_PROJECTS,
  UPDATE_PROJECTS_SEARCH,
  UPDATE_COMMENTS
} from './constants'
import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'

const addProject = (prev, { project, hierarchyType }) => {
  if (hierarchyType === 'leveraged') return [project]
  if (prev.map(x => x.id).includes(project.id)) return prev
  return prev.concat(project)
}

const removeProject = (prev, { id }) => {
  return prev.filter(x => x.id != id)
}

const updateComments = (prev, { id, comments }) => 
  prev.map(proj => proj.id === id ? { ...proj, comments: comments.substr(0,100) } : proj)

const active = createReducer(false, {
  [OPEN_DIALOG]: () => true,
  [CLOSE_DIALOG]: () => false
})

const hierarchy = createReducer(null, {
  [UPDATE_HIERARCHY_TYPE]: (_, { value }) => value,
})

const projects = createReducer([], {
  [ADD_PROJECT]: addProject,
  [REMOVE_PROJECT]: removeProject,
  [UPDATE_PROJECTS]: (_, { projects }) => projects.map(p => ({...p, comments: p.comments === null ? '' : p.comments})),
  [UPDATE_COMMENTS]: updateComments
})

const search = createReducer([], {
  [UPDATE_PROJECTS_SEARCH] : (prev, { projects }) => {
      if (!projects) return prev
      return projects.map(proj => ({
      value: proj.id,
      label: `${proj.id} | ${proj.name} | ${proj.sku} (AE Resource Level: ${proj.aeResourceLevel})`,
      comments: '',
      ...proj
    })
  )}
})

export default combineReducers({
  active,
  hierarchy,
  projects,
  search
})
